import { findNode } from "@/lib/tree/tree";
import { documentStore, uiStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { forceNextTick } from "@/util/force-next-tick";

export function findFirstChildOfElementBeingInlineEdited():
  | TreeNode["id"]
  | null {
  if (!uiStore.inlineEditingContext) {
    return null;
  }

  const inlineEditingContextElementId = uiStore.inlineEditingContext.elementId;
  const inlineEditingElement = findNode(
    documentStore.document.tree,
    inlineEditingContextElementId
  );

  if (!inlineEditingElement || !inlineEditingElement.children.length) {
    return null;
  }

  return inlineEditingElement.children[0].id;
}

export async function triggerSsrRefreshForElementContainingGlobalBlock(
  elementId: TreeNode["id"]
) {
  forceNextTick(() => {
    uiStore.setRefreshSsrElementId(elementId);
  });
}
